import _toConsumableArray from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { AmplitudeEnvelope } from "../component/envelope/AmplitudeEnvelope";
import { Envelope } from "../component/envelope/Envelope";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { omitFromObject, optionsFromArguments } from "../core/util/Defaults";
import { readOnly } from "../core/util/Interface";
import { OmniOscillator } from "../source/oscillator/OmniOscillator";
import { Source } from "../source/Source";
import { Monophonic } from "./Monophonic";
/**
 * Synth is composed simply of a [[OmniOscillator]] routed through an [[AmplitudeEnvelope]].
 * ```
 * +----------------+   +-------------------+
 * | OmniOscillator +>--> AmplitudeEnvelope +>--> Output
 * +----------------+   +-------------------+
 * ```
 * @example
 * const synth = new Tone.Synth().toDestination();
 * synth.triggerAttackRelease("C4", "8n");
 * @category Instrument
 */

export var Synth = /*#__PURE__*/function (_Monophonic) {
  _inherits(Synth, _Monophonic);

  var _super = _createSuper(Synth);

  function Synth() {
    var _this;

    _classCallCheck(this, Synth);

    _this = _super.call(this, optionsFromArguments(Synth.getDefaults(), arguments));
    _this.name = "Synth";
    var options = optionsFromArguments(Synth.getDefaults(), arguments);
    _this.oscillator = new OmniOscillator(Object.assign({
      context: _this.context,
      detune: options.detune,
      onstop: function onstop() {
        return _this.onsilence(_assertThisInitialized(_this));
      }
    }, options.oscillator));
    _this.frequency = _this.oscillator.frequency;
    _this.detune = _this.oscillator.detune;
    _this.envelope = new AmplitudeEnvelope(Object.assign({
      context: _this.context
    }, options.envelope)); // connect the oscillators to the output

    _this.oscillator.chain(_this.envelope, _this.output);

    readOnly(_assertThisInitialized(_this), ["oscillator", "frequency", "detune", "envelope"]);
    return _this;
  }

  _createClass(Synth, [{
    key: "_triggerEnvelopeAttack",

    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */
    value: function _triggerEnvelopeAttack(time, velocity) {
      // the envelopes
      this.envelope.triggerAttack(time, velocity);
      this.oscillator.start(time); // if there is no release portion, stop the oscillator

      if (this.envelope.sustain === 0) {
        var computedAttack = this.toSeconds(this.envelope.attack);
        var computedDecay = this.toSeconds(this.envelope.decay);
        this.oscillator.stop(time + computedAttack + computedDecay);
      }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */

  }, {
    key: "_triggerEnvelopeRelease",
    value: function _triggerEnvelopeRelease(time) {
      this.envelope.triggerRelease(time);
      this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
  }, {
    key: "getLevelAtTime",
    value: function getLevelAtTime(time) {
      time = this.toSeconds(time);
      return this.envelope.getValueAtTime(time);
    }
    /**
     * clean up
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Synth.prototype), "dispose", this).call(this);

      this.oscillator.dispose();
      this.envelope.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Monophonic.getDefaults(), {
        envelope: Object.assign(omitFromObject(Envelope.getDefaults(), Object.keys(ToneAudioNode.getDefaults())), {
          attack: 0.005,
          decay: 0.1,
          release: 1,
          sustain: 0.3
        }),
        oscillator: Object.assign(omitFromObject(OmniOscillator.getDefaults(), [].concat(_toConsumableArray(Object.keys(Source.getDefaults())), ["frequency", "detune"])), {
          type: "triangle"
        })
      });
    }
  }]);

  return Synth;
}(Monophonic);